export const INFO_TIPO = {
  ATESTADO: "Atestado",
  "ATENDIMENTO CLÍNICO": "Atendimento",
  EXAMES: "Exames",
  MEDICAMENTO: "Medicamento",
  PRESCRICOES: "Prescrições",
  "SOLICITACAO REGULADA": "Solicitacao Regulada",
  VACINA: "Vacina",
  ALERGIA: "Alergia",
  "DIARIO DE SAUDE": "Diario de Saude",
  "MEDICAMENTO DECLARADO": "Medicamento Declarado",
  "ALERGIAS": "Alergias",
  "PRESSAO": "Pressao",
  "GLICOSE": "Glicose",
  "IMC": "Imc",
  "MEDICAMENTOS DECLARADOS": "Medicamentos Declarados"

};
